import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import axios from 'axios';
import translate from '../../../../commonComponents/translate';
import withCSRF from '../../../../commonComponents/withCSRF';
import { compose } from '../../../../services/utilityFunctions';
import ServerSideList from '../../../../commonComponents/lists/ServerSideList';
import UserProp from '../../../../commonComponents/propTypes/userProp';
import BasicModal from '../../../../commonComponents/modal/BasicModal';
import { useModal } from '../../../../services/customHooks';
import Notifications from '../../../../services/notifications';

function FollowingTab({ t, _csrf, user }) {
  const tableId = 'followingList';
  const tableRef = useRef(null);

  const [showModal, setShowModal] = useModal({ show: false, data: null });
  const [isLoading, setIsLoading] = useState(false);

  function handleListInitialization() {
    $(`#${tableId}`).on('click', '.unfollow-btn', function changeHandler() {
      const $btn = $(this);
      const productId = $btn.data('product');
      setShowModal({ show: true, data: productId });
    });
  }

  const handleUnfollowProduct = async (save, productId) => {
    if (save) {
      try {
        setIsLoading(true);
        await axios.put(
          `/api/market/product/${productId}/unfollow`,
          {
            user: user?._id,
          },
          {
            headers: {
              'X-Gamification-API': 'Games',
              'Accept-Version': '1.0.0',
              'X-CSRF-Token': _csrf,
              _csrf,
            },
          },
        );

        Notifications.showNotificationSuccess(
          t('success'),
          t('product.unfollowing.success'),
        );
      } catch (err) {
        Notifications.showNotificationError(
          err,
          t('product.unfollowing.error'),
        );
      } finally {
        setIsLoading(false);
      }
    }

    setShowModal({ show: false, data: null });
    if (save && tableRef?.current) {
      tableRef.current.forceReload();
    }
  };

  return (
    <div className="m-portlet m-portlet--full-height following-tab">
      {showModal?.show && (
        <BasicModal
          onClose={save => handleUnfollowProduct(save, showModal?.data?._id)}
          id="unfollowModal"
          title={t('unfollow')}
          saveMessage={t('yes')}
          cancelMessage={t('no')}
          showCloseOnTop
          isLoading={isLoading}
        >
          <span>{t('unfollow.product.content', showModal?.data?.name)}</span>
        </BasicModal>
      )}

      <h4 className="m-form__section">{t('following')}</h4>

      <ServerSideList
        id={tableId}
        ref={tableRef}
        dataSourceURL={`/table/market/product/minified/list?followingUser=${user?._id}`}
        query={{}}
        onInit={handleListInitialization}
        columns={[
          {
            field: 'name',
            title: t('name'),
            sortable: false,
          },
          {
            field: 'actions',
            width: 40,
            textAlign: 'center',
            title: '',
            sortable: false,
            overflow: 'visible',
            template: product =>
              renderToStaticMarkup(
                <button
                  type="button"
                  onClick={() => {}}
                  data-product={JSON.stringify(product)}
                  className="unfollow-btn"
                >
                  {t('unfollow')}
                </button>,
              ),
          },
        ]}
      />
    </div>
  );
}

FollowingTab.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  user: PropTypes.shape(UserProp.propType).isRequired,
};

export default compose(translate, withCSRF)(FollowingTab);
